import { Component, Inject, ViewEncapsulation, ViewChild, Input } from '@angular/core';
import { filter } from 'rxjs/operators';
import { ReportViewerService } from '../../services/report-viewer.service';
import { GetRegNameSearchReportQuery, GetRecNameSearchReportQuery } from '../../viewmodels/ISearchService';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { ActivatedRoute, Router } from '@angular/router';
import { DxReportViewerComponent } from 'devexpress-reporting-angular';
import { ActionId, ReportPreview, ExportFormatID } from 'devexpress-reporting/dx-webdocumentviewer'
import Swal from 'sweetalert2'
import * as ko from 'knockout';
import { observable } from 'rxjs';
import { ExportHandler } from 'devexpress-reporting/viewer/internal/_exportHandler';

import { RecSearchService } from '../../../rec-search/rec-search-service';
import { NavMenuService } from '../../../shared/services/nav-menu-service';


@Component({
  selector: 'report-viewer-plan',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './report-viewer-plan.component.html',
  styleUrls: [
    //"../../../../../node_modules/jquery-ui/themes/base/all.css",
    //"../../../../../node_modules/devextreme/dist/css/dx.common.css",
    //"../../../../../node_modules/devextreme/dist/css/dx.light.css",
    "../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css",
    "../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.light.css",
    "../../../../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css"
  ]
})
export class ReportViewerPlanComponent {
  @ViewChild(DxReportViewerComponent, { static: false }) viewer: DxReportViewerComponent;
  reportUrl: string; //= "RecNameSearchReport1";
  invokeAction: string = '/DXXRDV';
  @Input() isNewTab: boolean;
  oldAction: Function;
  //invokeAction: string = 'mydocviewercontroller'

   back(url) {

    if (this.isNewTab) {

      //window.opener = 'Self';
      window.open('', '_parent', '');
      window.close();
    }
    else {
      try {
        this.service.logInfo('Clicked back button');
        this.nav.show();
        if (localStorage.getItem('recNameSearchResults') !== null) {
          console.log('remove from localStorage');
          localStorage.removeItem('recNameSearchResults');
        }
        this.router.navigate([url]);
      }
      catch (error) {
        this.service.logError(error);
      }
    }
  }

  CustomizeMenuActions(event) {
    //var actionPrevPage = s.args.GetById(ActionId.Print);

    //var printAction = event.args.GetById(ActionId.Print);
    //if (printAction)
    //    printAction.clickAction = (report) => {
    //        event.sender.PerformCustomDocumentOperation("Print", true)
    //            .done(() => {
    //                //window.open("/Home/PrintDocument", "_blank");
    //              Swal.fire("Document exported");
    //            });
    //    };
        	

    //var exportAction = event.args.GetById(ActionId.ExportTo);
    //if (exportAction)
    //  exportAction.clickAction = (report) => this.ExportIntercept(event);



        var actionExportTo = event.args.GetById(ActionId.ExportTo);
    var actionExportToClick = actionExportTo.clickAction;

    actionExportTo.clickAction = (arg) => {

        //   if (arg.itemData.format === "pdf") {
        //        //Override PDF Export command here
        //        event.sender.PerformCustomDocumentOperation("ExportToPDF", true)
        //    }
        //else
        actionExportToClick(arg);

        }        

  }

  ExportIntercept(event) {
    event.sender.PerformCustomDocumentOperation("ExportToPDF", true)
                .done(() => {
                    Swal.fire("Document exported");
                });


  }

  CustomizeExportOptions(event) {
    //var q = event.args._options.exportOptions.pdf;

    var model = event.args.GetExportOptionsModel(ExportFormatID.PDF);
    
    //model.exportHyperlinks(false);


    if (model) model.clickAction = (report) => {
      event.sender.PerformCustomDocumentOperation("ExportToPDF", true)
        .done(() => {
         //window.open("/Home/PrintDocument", "_blank");
          Swal.fire("Document exported");
        });
    };
  }

    //  print() {
    //    this.viewer.bindingSender.Export();
    //}  

  constructor(@Inject('BASE_URL') public hostUrl: string, private route: ActivatedRoute, private router: Router, public nav: NavMenuService, private service: RecSearchService) {

  
    /*TODO: Inject the store and get the search params */
    this.reportUrl = this.route.snapshot.paramMap.get('repName');

    //let getRecNameSearchReportQuery = new GetRecNameSearchReportQuery({
    //    lastName: "BAKER",
    //    firstName: "",
    //    fromDate: "2018-02-13T16:35:14.394Z",
    //    toDate: "2020-03-13T15:35:25.324Z",
    //    roleId: 0,
    //    towns: new Array<string>(),
    //    doctypes: new Array<string>(),
    //    sortBy: new Array<string>(),
    //    sortDirection: "desc",
    //    filter: new Array<string>()
    //});

    //this.service.getRecNameSearchReport(getRecNameSearchReportQuery).subscribe((reportName) => {
    //    this.reportUrl = reportName.reportName;
    //})

    //let getRegNameSearchReportQuery = new GetRegNameSearchReportQuery({
    //  lastName: "BAKER",
    //  firstName: "",
    //  fromDate: "2018-02-13T16:35:14.394Z",
    //  toDate: "2020-03-13T15:35:25.324Z",
    //  roleId: 0,
    //  towns: new Array<string>(),
    //  doctypes: new Array<string>(),
    //  sortBy: new Array<string>(),
    //  sortDirection: "desc",
    //  filter: new Array<string>()
    //});

    //this.service.getRegNameSearchReport(getRegNameSearchReportQuery).subscribe((reportName) => {
    //  this.reportUrl = reportName.reportName;
    //})


  }
}
